<template>
  <div
    @click="$emit('click')"
    :style="containerStyles"
    class="show-more__container"
  >
    Alle {{ totalElements }} Bilder anzeigen
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "constants/theme"

export default defineComponent({
  name: "GalleryShowMore",
  props: {
    totalElements: { type: Number, required: true },
    size: { type: Number, default: 128 },
  },
  setup(props) {
    const containerStyles: Partial<CSSStyleDeclaration> = {
      backgroundColor: THEME.colors.light.primary,
      color: THEME.colors.light.lightGrey,
    }

    if (props.size > 0) {
      containerStyles.height = `${props.size}px`
      containerStyles.width = `${props.size}px`
    }

    return {
      containerStyles,
    }
  },
})
</script>

<style scoped>
.show-more__container {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 8px;
  font-weight: bold;
  border-radius: 4px;
  aspect-ratio: 1 / 1;
  cursor: pointer;
  height: 100%;
}
</style>
